var _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4000 7000",
    style: {
      enableBackground: "new 0 0 4000 7000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.238,
    y: 1.364,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#01052D"
    },
    width: 3999.229,
    height: 6998.636
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1.238,737.752C1259.763-552.224,3174.317,2484.15,4000.466,1599.701V1.364H1.238V737.752z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034773293897884783550000003082061089786376832_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171716199317222962000000014145296330811871148_",
    gradientUnits: "userSpaceOnUse",
    x1: 2118.679,
    y1: 815.6461,
    x2: 3160.0198,
    y2: -512.8309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#021B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020C6A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.238,
    y: -552.224,
    style: {
      clipPath: "url(#SVGID_00000034773293897884783550000003082061089786376832_)",
      fill: "url(#SVGID_00000171716199317222962000000014145296330811871148_)"
    },
    width: 3999.229,
    height: 3036.374
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000055708725804472496740000011150371498279685769_",
    d: "M1.238,1316.318 C1259.763,26.347,3174.317,3062.716,4000.466,2178.27v-578.569C3174.317,2484.15,1259.763-552.224,1.238,737.752V1316.318z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000095338057277111693500000018004270679805226897_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055708725804472496740000011150371498279685769_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152981805051010165780000012785135645944441268_",
    gradientUnits: "userSpaceOnUse",
    x1: 1075.1621,
    y1: 2255.2219,
    x2: 2484.3496,
    y2: 732.9476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#021B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01052D"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.238,
    y: -552.224,
    style: {
      clipPath: "url(#SVGID_00000095338057277111693500000018004270679805226897_)",
      fill: "url(#SVGID_00000152981805051010165780000012785135645944441268_)"
    },
    width: 3999.229,
    height: 3614.941
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000062164806063800916580000004540556471658789784_",
    d: "M4000.466,6263.611 C2741.945,7553.587,827.387,4517.213,1.238,5401.665V7000h3999.229V6263.611z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163763140051334265930000018241114334573670586_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062164806063800916580000004540556471658789784_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116221396805955453110000007004183049398540207_",
    gradientUnits: "userSpaceOnUse",
    x1: 1883.0444,
    y1: 6185.7046,
    x2: 841.7975,
    y2: 7514.1816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#021B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020C6A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.238,
    y: 4517.213,
    style: {
      clipPath: "url(#SVGID_00000163763140051334265930000018241114334573670586_)",
      fill: "url(#SVGID_00000116221396805955453110000007004183049398540207_)"
    },
    width: 3999.229,
    height: 3036.374
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000179620532643794169580000012632901330008282801_",
    d: "M4000.466,5685.044 C2741.945,6975.017,827.387,3938.646,1.238,4823.093v578.571c826.149-884.452,2740.708,2151.923,3999.229,861.947V5685.044z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000007391286424293770720000011412595250717571483_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179620532643794169580000012632901330008282801_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141439818831775701990000014934661383342125483_",
    gradientUnits: "userSpaceOnUse",
    x1: 2926.5256,
    y1: 4746.0947,
    x2: 1517.3389,
    y2: 6268.4644
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#021B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01052D"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.238,
    y: 3938.646,
    style: {
      clipPath: "url(#SVGID_00000007391286424293770720000011412595250717571483_)",
      fill: "url(#SVGID_00000141439818831775701990000014934661383342125483_)"
    },
    width: 3999.229,
    height: 3614.941
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000128475336011886705550000005581698512115220372_",
    d: "M4000.466,2178.27 c-210.216,225.05-490.905,196.242-813.321,49.444c420.437,1651.868-1083.948,2067.128-324.177,3715.658 c404.298,123.341,795.169,92.558,1137.498-258.328V2178.27z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029024009645935233970000008671483322839548585_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128475336011886705550000005581698512115220372_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091011994209336667070000016100057225283537028_",
    gradientUnits: "userSpaceOnUse",
    x1: 3567.5999,
    y1: 4253.6338,
    x2: 1770.6262,
    y2: 3796.7231
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#01052D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#021B8C"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2103.197,
    y: 2178.27,
    style: {
      clipPath: "url(#SVGID_00000029024009645935233970000008671483322839548585_)",
      fill: "url(#SVGID_00000091011994209336667070000016100057225283537028_)"
    },
    width: 1897.269,
    height: 3888.443
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000160890279988943232060000010117104756507854013_",
    d: "M2424.764,1769.956 c0,0-631.01,1341.539,472.341,2318.414c228.72-516.887,500.475-1033.879,290.04-1860.656 C2951.559,2120.452,2693.7,1950.196,2424.764,1769.956"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165193447408043840230000009665870067611926171_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160890279988943232060000010117104756507854013_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141431291445530821410000008081300903799809943_",
    gradientUnits: "userSpaceOnUse",
    x1: 3068.6042,
    y1: 2912.8049,
    x2: 1545.0005,
    y2: 2965.5044
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#01052D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#021B8C"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1793.753,
    y: 1769.956,
    style: {
      clipPath: "url(#SVGID_00000165193447408043840230000009665870067611926171_)",
      fill: "url(#SVGID_00000141431291445530821410000008081300903799809943_)"
    },
    width: 1603.826,
    height: 2318.414
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000034804938196367584890000010686083405598452131_",
    d: "M1.238,4823.093 c210.216-225.048,490.905-196.24,813.325-49.444C394.121,3121.783,1898.511,2706.52,1138.74,1057.991 C734.442,934.65,343.571,965.435,1.238,1316.318V4823.093z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021819714685339242660000005910376709130852278_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034804938196367584890000010686083405598452131_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018934663785925549640000005532314454970019503_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.0512,
    y1: 2747.687,
    x2: 2231.0225,
    y2: 3204.6941
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#01052D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#021B8C"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.238,
    y: 934.65,
    style: {
      clipPath: "url(#SVGID_00000021819714685339242660000005910376709130852278_)",
      fill: "url(#SVGID_00000018934663785925549640000005532314454970019503_)"
    },
    width: 1897.274,
    height: 3888.443
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000013153288393440524150000004211422167843336074_",
    d: "M1576.944,5231.406 c0,0,631.011-1341.539-472.346-2318.416c-228.715,516.889-500.47,1033.881-290.036,1860.658 C1050.149,4880.911,1308.009,5051.164,1576.944,5231.406"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078763906752930463950000001157959010102547109_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013153288393440524150000004211422167843336074_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147919296827880748120000006122522286601883525_",
    gradientUnits: "userSpaceOnUse",
    x1: 963.3102,
    y1: 4024.9751,
    x2: 2450.8337,
    y2: 4183.6396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#01052D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#021B8C"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 604.129,
    y: 2912.99,
    style: {
      clipPath: "url(#SVGID_00000078763906752930463950000001157959010102547109_)",
      fill: "url(#SVGID_00000147919296827880748120000006122522286601883525_)"
    },
    width: 1603.826,
    height: 2318.416
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.d796c4539c312f9d8f00bbb0a8ac78c7.svg";
export { ForwardRef as ReactComponent };